import React, { useEffect, useState } from 'react';
import { db, auth } from '../firebase';
import { collection, getDocs, updateDoc, doc, getDoc } from 'firebase/firestore';
import '../style/common.css';
import './form.css';
import './AdminDashboard.css';
import AdminSidebar from '../components/AdminSidebar';

function AssignPO() {
  const [pos, setPOs] = useState([]);
  const [pms, setPMs] = useState([]);
  const [selected, setSelected] = useState({ po: '', pm: '' });
  const [currentUser, setCurrentUser] = useState(null);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    const fetchData = async () => {
      const poSnap = await getDocs(collection(db, 'purchase_orders'));
      const userSnap = await getDocs(collection(db, 'users'));

      const poList = poSnap.docs.map(d => ({ id: d.id, ...d.data() }))
        .filter(po => !po.assigned_to); // only unassigned POs

      const pmList = userSnap.docs.map(d => ({ id: d.id, ...d.data() }))
        .filter(u => u.role === 'pm');

      setPOs(poList);
      setPMs(pmList);
    };

    const fetchCurrentUser = async () => {
      const userRef = doc(db, 'users', auth.currentUser.uid);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        setCurrentUser(userSnap.data());
      }
    };

    fetchCurrentUser();
    fetchData();
  }, []);

  const assignPO = async () => {
    if (!selected.po || !selected.pm) {
      setMessage({ type: 'error', text: 'Please select both PO and PM.' });
      return;
    }

    try {
      const poRef = doc(db, 'purchase_orders', selected.po);
      await updateDoc(poRef, {
        assigned_to: selected.pm
      });
      setMessage({ type: 'success', text: 'PO assigned successfully.' });

      // Refresh PO list
      setPOs(prev => prev.filter(po => po.id !== selected.po));
      setSelected({ po: '', pm: '' });
    } catch (err) {
      console.error('Assignment error:', err);
      setMessage({ type: 'error', text: 'Failed to assign PO. Try again.' });
    }
  };

  return (
    <div className="dashboard-wrapper">
      <AdminSidebar user={currentUser} />

      <div className="dashboard-content">
        <h2 className="form-title">Assign Purchase Order</h2>

        {message.text && (
          <div className={`form-alert ${message.type}`}>
            {message.text}
          </div>
        )}

        <form className="styled-form" onSubmit={(e) => e.preventDefault()}>
          <div className="form-row">
            <label>Select PO</label>
            <select
              value={selected.po}
              onChange={(e) => setSelected({ ...selected, po: e.target.value })}
            >
              <option value="">-- Select PO --</option>
              {pos.map(po => (
                <option key={po.id} value={po.id}>{po.po_number}</option>
              ))}
            </select>
          </div>

          <div className="form-row">
            <label>Select Project Manager</label>
            <select
              value={selected.pm}
              onChange={(e) => setSelected({ ...selected, pm: e.target.value })}
            >
              <option value="">-- Select PM --</option>
              {pms.map(pm => (
                <option key={pm.id} value={pm.id}>{pm.name} ({pm.email})</option>
              ))}
            </select>
          </div>

          <button className="submit-btn" onClick={assignPO}>Assign PO</button>
        </form>
      </div>
    </div>
  );
}

export default AssignPO;
